<template>
  <el-popover
    class="project-tree-input-container"
    v-model="isProjectTreeShowed"
    placement="bottom-start"
    :width="popoverWidth"
    :trigger="displayMode === 0 ? 'focus' : 'click'"
    transition="none"
    :disabled="_disabled"
    @show="projectTreeShowed"
    @hide="projectTreeHidden"
  >
    <el-input
      placeholder="搜索"
      v-if="isFilter"
      v-model="filterName"
      class="filter"
      clearable
    ></el-input>
    <tree
      :style="{ height: popoverHeight + 'px' }"
      ref="projectTree"
      :props="proctProps"
      :data="procttree"
      :default-expanded-keys="proctExpandKeys"
      node-key="id"
      @treenode-click="projectSelected(arguments[0])"
      v-loading="
        (mode === 0 && proctLoading) || (mode === 1 && isTreeDataLoading)
      "
    ></tree>
    <el-input
      v-if="displayMode === 0"
      slot="reference"
      :placeholder="placeholder"
      :value="value"
      :disabled="_disabled"
      @input="$emit('input', arguments[0])"
      clearable
    ></el-input>
    <div v-else class="project-text-container" slot="reference">
      {{ value ? value : "项目" }}
    </div>
  </el-popover>
</template>
<script>
import Tree from '@/components/tree/treeNew'
import projectTreeMixin from '@/pages/mixins/proctTree'

export default {
  name: 'projectTreeInput',
  mixins: [projectTreeMixin],
  components: {
    Tree
  },
  props: {
    value: String,
    disabled: Boolean,
    selectDefault: {
      type: Boolean
    },
    popoverWidth: {
      type: Number,
      default: 200
    },
    popoverHeight: {
      type: Number,
      default: 400
    },
    placeholder: {
      type: String,
      default: '请选择项目'
    },
    mode: {
      // 0：控件自己取数据, 1：控件父级传入数据
      type: Number,
      default: 0
    },
    displayMode: {
      // 0：input模式, 1：label模式
      type: Number,
      default: 0
    },
    // 以下是当mode等于1时，父级出入的tree数据
    isTreeDataLoading: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default () {
        return []
      }
    },
    treeProps: {
      type: Object,
      default () {
        return {
          children: 'children',
          label: 'name'
        }
      }
    },
    treeDefaultExpandedKeys: {
      type: Array,
      default () {
        return []
      }
    },
    isFilter: Boolean // 是否搜索框
  },
  data () {
    return {
      proctShouldLoadOnMount: this.mode === 0,
      proctLoadingMode: 0,
      isProjectTreeShowed: false,
      procttreeData: '',
      filterName: ''
    }
  },
  computed: {
    _disabled () {
      if (this.disabled) {
        return true
      } else if (this.displayMode === 1) {
        if (!this.procttree || !this.procttree.length) {
          return true
        } else if (
          !this.procttree[0].children ||
          this.procttree[0].children.length === 0
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  methods: {
    /**
     * 查找唯一管辖项目，非唯一返回null
     * @param list Array,
     * @param keys Array, 需要展开的条目ID，这是一个outer引用参数
     * @returns Object or null
     */
    findUniqueProject (list, keys) {
      if (list && list.length === 1) {
        const item = list[0]
        if (item.spatialCode >= 200000000) {
          keys.push(item.id)
          return item
        } else if (item.children && item.children.length === 1) {
          keys.push(item.id)
          return this.findUniqueProject(item.children, keys)
        } else {
          // sonar规则校验语法必须else
        }
      }
      return null
    },
    expandProjectTree () {
      if (this.procttree && this.procttree.length) {
        const keys = []
        const defaultProject = this.findUniqueProject(this.procttree, keys)
        if (defaultProject) {
          this.proctExpandKeys = keys
        }
      }
    },
    projectTreeShowed () {
      this.expandProjectTree()
      this.$emit('projectTreeShowed')
    },
    projectTreeHidden () {
      this.$emit('projectTreeHidden')
    },
    projectSelected (val, isAutoSelected = false) {
      this.$emit('projectSelected', val, isAutoSelected)
    },
    showProjectTree () {
      this.isProjectTreeShowed = true
    },
    hideProjectTree () {
      this.isProjectTreeShowed = false
    },
    treeFilter (val) {
      this.$refs.projectTree && this.$refs.projectTree.filter(val)
    },
    setTreeCurrentKey (val) {
      this.$refs.projectTree && this.$refs.projectTree.setCurrentKey(val)
    }
  },
  watch: {
    procttree (val) {
      if (this.procttreeData !== this.procttree) {
        if (this.isProjectTreeShowed) {
          this.expandProjectTree()
        }
        const defaultProject = this.findUniqueProject(val, [])
        if (defaultProject) {
          this.procttree = this.procttreeData = [defaultProject]
          this.projectSelected(defaultProject, true)
        }
        if (this.mode === 0) {
          this.$emit('projectTreeDataLoaded', val)
        }
      }
    },
    treeData (val) {
      this.procttree = val
    },
    proctFirstNode (val) {
      if (this.selectDefault && val) {
        this.projectSelected(this.proctFirstNode, true)
      }
    },
    filterName (val) {
      setTimeout(() => {
        this.treeFilter(val)
      }, 100)
    }
  },
  mounted () {
    if (this.mode === 1) {
      this.proctProps = this.treeProps
      this.procttree = this.treeData
      this.proctExpandKeys = this.treeDefaultExpandedKeys
    }
  }
}
</script>
<style lang="less" scoped>
.project-tree-input-container {
  > .project-text-container {
    cursor: pointer;
    > i.location {
      color: firebrick;
      font-size: 18px;
    }
  }
}
.filter{
  height:50px
}
</style>



// WEBPACK FOOTER //
// src/components/projectTreeInput.vue